// extracted by mini-css-extract-plugin
module.exports = {"confetti":"style_confetti__37LEQ","confetti-piece":"style_confetti-piece__228JZ","makeItRain":"style_makeItRain__3Mknc"};